<template>
    <Head>
        <title>Vul je rekening</title>
        <meta head-key="description" name="description"
              content="Bij RekeningOpvuller.nl vind je de goedkoopste en leukste producten om je winkelmandje te vullen. Zo betaal je nooit meer teveel en heb je altijd gratis verzending."/>
        <meta head-key="keywords" content="rekening, vullen, gratis, verzending, goedkoopste, producten, webshops" />
        <link rel="shortcut icon" href="/favicon.ico"/>
    </Head>

    <header class="container relative bg-white">
        <nav aria-label="Top">
            <div class="border-b border-gray-200">
                <div class="h-16 flex items-center justify-between">
                    <div class="flex-1 block self-stretch h-full flex space-x-8">
<!--                        <Link-->
<!--                            href="/"-->
<!--                            class="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800"-->
<!--                        >-->
<!--                            Home-->
<!--                        </Link>-->
                    </div>

                    <!-- Logo -->
                    <Link
                        href="/"
                        class="flex"
                    >
                        <span class="sr-only">RekeningOpvuller.nl</span>
                        <img class="h-12 w-auto"
                             src="/images/logo.png"
                             alt=""/>
                    </Link>

                    <div class="flex-1 flex items-center justify-end">
<!--                        <a href="#" class="p-2 text-gray-400 hover:text-gray-500 lg:ml-4">-->
<!--                            <span class="sr-only">Account</span>-->
<!--                            <UserIcon class="w-6 h-6" aria-hidden="true"/>-->
<!--                        </a>-->
                    </div>
                </div>
            </div>
        </nav>
    </header>

    <main class="pb-24">
        <slot/>
    </main>

    <footer aria-labelledby="footer-heading">
        <h2 id="footer-heading" class="sr-only">Footer</h2>
        <div class="border-t border-gray-100 py-10 sm:flex sm:items-center sm:justify-between">
            <div class="container">
                <div class="flex items-center justify-center text-sm text-gray-500">
                    <p>RekeningOpvuller.nl - Vul je rekening!</p>
                </div>
                <p class="mt-6 text-sm text-gray-500 text-center sm:mt-0">
                    Alle rechten voorbehouden &copy;{{ new Date().getFullYear() }}
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'

export default {
    components: {
        Head,
        Link,
    },

}
</script>
